import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { RadioGroup } from "../components/RadioGroup";
import { RadioButton } from "../components/RadioButton";
import { InstrumentBase } from "../instruments/InstrumentBase";
import { getClipDisplayName } from "$utils/misc";
import { getCurrentProject } from "../sessionManager";

export const ClipSelector = ({ className, instrument, buttonWidth, minHeight }) => {
    return (
        <div data-widget-id="clipSelect" className={`gruf-selector-clips buttongroup ${className}`} style={{ minHeight }}>
            <RadioGroup>{[...Array(InstrumentBase.numClips).keys()].map(i =>
                <ClipButton key={"clip_" + i} instrument={instrument} width={buttonWidth} number={i}/>
            )}</RadioGroup>
        </div>
    );
};

const ClipButton = ({instrument, width, number}) => {
    const isSelected = useSelector(createSelector(instrument.getDisplayParameterSelector("clipNumber"), clipNumber => clipNumber === number));
    const isPlayback = useSelector(createSelector(instrument.getPlaybackParameterSelector("clipNumber"), playbackClipNumber => playbackClipNumber === number));
    return <RadioButton
        style={{width}}
        className={`clip-button flex justify-center items-center ${isPlayback ? "playback" : ""}`}
        checked={isSelected}
        onNewValue={(value) => { value && instrument.updateParametreInstrument("clipNumber", number) }}
        onClick={e => e.stopPropagation()} // this is for when it's on top of other button, such as in the station selector
    >
        {getClipDisplayName(number)}
    </RadioButton>
}